import { Component } from '@angular/core';
import { state, trigger, style, transition, animate } from '@angular/animations';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-checkbox-message',
    templateUrl: './checkbox-message.component.html',
    styleUrls: ['./checkbox-message.component.scss'],
    animations: [
        trigger('flyInOut', [
            state('inactive', style({ top: 0 })),
            state('active', style({ top: 40 })),
            state('removed', style({ top: 0, opacity: 0 })),
            transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
        ]),
    ],
    preserveWhitespaces: false,
    standalone: false
})
export class CheckboxMessageComponent extends Toast {

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }
}
